import { render, staticRenderFns } from "./FacebookLoginCard.vue?vue&type=template&id=901b94d6"
import script from "./FacebookLoginCard.vue?vue&type=script&lang=ts"
export * from "./FacebookLoginCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports